export default __webpack_public_path__ + "static/media/edit.abfef11c.gif";